import React, { useEffect, useRef } from "react";
import { languages, backend, frontend, tools } from "../content/stack";
import { AnimatePresence, motion } from "framer-motion";
import XImage from "../images/x.png";

export const Stack = ({ close }) => {
	const [scroll, setScroll] = React.useState(0);
	const ref = useRef(null);
	useEffect(() => {
		ref.current.addEventListener("scroll", () => {
			setScroll(ref.current.scrollTop);
		});
	}, [])

	return (
		<motion.div
			ref={ref}
			className="bg-black relative h-screen overflow-auto no-scrollbar w-full max-w-6xl mx-auto "
			initial={{
				y: "100%",
			}}
			animate={{
				y: "0",
			}}
			transition={{
				duration: 0.6,
			}}
		>
			<motion.div
				className={`flex flex-col items-left text-left w-full sticky top-0 left-0`}
				transition={{ duration: 0.3 }}
			>
				<div className="bg-black p-2">
					<div className="absolute top-4 right-4 lg:right-0">
						<img
							src={XImage}
							className="h-6 cursor-pointer hover:scale-110"
							onClick={close}
							style={{
								filter: "invert(1)",
							}}
						/>
					</div>
					<h1 className="text-3xl font-black blue-color h-12">My Stack</h1>
				</div>
				<AnimatePresence>
					{scroll < 1 && (
						<motion.h3
							className="lg:text-xl text-white bg-black p-2 absolute top-12 w-full rounded-b-xl"
							initial={{ opacity: 0, y: -10 }}
							animate={{ opacity: 1, y: 0 }}
							exit={{ opacity: 0, y: -10 }}
							transition={{ duration: 0.3 }}
						>
							These are the tools that I use daily to build my projects.
						</motion.h3>
					)}
				</AnimatePresence>
			</motion.div>
			<div className="flex flex-col p-4 gap-4 items-center pt-10" >
				<h1 className="text-white text-2xl py-10 text-center w-full font-black">
					Languages
				</h1>
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10">
					{languages.map((stack) => {
						return (
							<div className="bg-white rounded-2xl flex gap-2 md:gap-4 items-center justify-left px-1 py-6 md:p-4 flex-col grid-item shadow mx-auto">
								<img src={stack.image} className="rounded-t-2xl w-20 h-20" />
								<p className="font-black">{stack.name}</p>
							</div>
						);
					})}
				</div>
				<h1 className="text-white text-2xl py-10 text-center w-full font-black">
					Frontend
				</h1>
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10">
					{frontend.map((stack) => {
						return (
							<div className="bg-white rounded-2xl flex gap-2 md:gap-4 items-center justify-left px-1 py-6 md:p-4 flex-col grid-item shadow mx-auto">
								<img src={stack.image} className="rounded-t-2xl w-20 h-20" />
								<p className="font-black">{stack.name}</p>
							</div>
						);
					})}
				</div>
				<h1 className="text-white text-2xl py-10 text-center w-full font-black">
					Backend
				</h1>
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10">
					{backend.map((stack) => {
						return (
							<div className="bg-white rounded-2xl flex gap-2 md:gap-4 items-center justify-left px-1 py-6 md:p-4 flex-col grid-item shadow mx-auto">
								<img src={stack.image} className="rounded-t-2xl w-20 h-20" />
								<p className="font-black">{stack.name}</p>
							</div>
						);
					})}
				</div>
				<h1 className="text-white text-2xl py-10 text-center w-full font-black">
					Tools
				</h1>
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-10">
					{tools.map((stack) => {
						return (
							<div className="bg-white rounded-2xl flex gap-2 md:gap-4 items-center justify-left px-1 py-6 md:p-4 flex-col grid-item shadow mx-auto">
								<img src={stack.image} className="rounded-t-2xl w-20 h-20" />
								<p className="font-black">{stack.name}</p>
							</div>
						);
					})}
				</div>

				<div className="my-10 mx-auto font-bold text-white">Learning more... </div>
			</div>
		</motion.div>
	);
};
